'use client';

import dynamic from 'next/dynamic';
import { useTranslations } from 'next-intl';
import CustomLink from 'components/shared/CustomLink';
import styles from './RingProUsScienceBanner.module.css';

/* WebGL only. The CSS gradient shows until the canvas draws, and stays
   if WebGL is unavailable. */
const MarbleShader = dynamic(() => import('./MarbleShader'), { ssr: false });

/**
 * Science strip under the measures carousel (Figma 2600:25). Copy and the
 * white pill stay as the frame. The background is a flat field in the
 * science orb's resting colours, not the glass ball.
 */
export const RingProUsScienceBanner = () => {
  const t = useTranslations('homepage');
  const k = (key: string) => `homepage.ringProUs.science.${key}`;

  return (
    <div className={styles.wrap}>
      <div className={styles.banner}>
        <MarbleShader className={styles.shader} />

        <div className={styles.copy}>
          <p className={styles.title}>{t(k('title'))}</p>
          <p className={styles.sub}>{t(k('sub'))}</p>
        </div>

        <CustomLink
          href="/science"
          className={styles.cta}
          data-buttontype="ring_pro_us_science_banner"
        >
          {t(k('cta'))}
        </CustomLink>
      </div>
    </div>
  );
};

export default RingProUsScienceBanner;
